@if(loader){
<app-loader></app-loader>
}
<p-card header="">
  <div class="">

  <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
    <div class="flex align-items-center">
  
      <div class="flex gap-2">
        <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
          routerLink="/home/createEmployees" pTooltip="Create Employee"></p-button>
  
      </div>
  
      <div class="flex align-items-center ml-3">
        <span class="p-input-icon-left" style="width: 200px;">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class="p-inputtext-sm w-full"
            (keyup.enter)="searchEmployee()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
        </span>
  
        <p-button icon="pi pi-search" (click)="searchEmployee()" [raised]="true" size="small" severity="info"
          [ngStyle]="{ height: '35px' }" class="ml-2"></p-button>
      </div>
  
      <p-button *ngIf="selectedEmployee.length === 1" label="Edit" icon="pi pi-user-edit" size="small"
        severity="secondary" (click)="editEmployee()" class="ml-2"></p-button>
  
      <p-button *ngIf="selectedEmployee.length > 0" label="Delete" icon="pi pi-trash" size="small" severity="danger"
        (click)="deleteEmployee()" class="ml-2"></p-button>
    </div>
  
    <h2 class="page-title-center">Employee List</h2>
  
  
    <div class="flex gap-2">
      <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="cancel()"></p-button>
      <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true" severity="info"></p-button>
    </div>
  
  </div>


    <p-table #dt1 [value]="EmployeeList" [scrollable]="true" scrollHeight="613px" styleClass="p-datatable-striped"
      responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
      (onPage)="loadEmployee($event)" [(selection)]="selectedEmployee" [globalFilterFields]="['deliverychallanNo']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10 ,15, 20]">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>Employee ID</th>
          <th>Employee Name</th>
          <th>Email</th>
          <th>Designation</th>
          <th>Location</th>
          <th>Reporting Manager</th>
          <th>Created By</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-emp>
        <tr>
          <td>
            <p-tableCheckbox [value]="emp"></p-tableCheckbox>
          </td>
          <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editEmployee(emp)">
            {{emp.employeeId}}
          </td>
          <td>{{ emp.firstName + ' ' + emp.lastName }}</td>
          <td>{{emp.email}}</td>
          <td>{{emp.designation}}</td>
          <td>{{emp.location}} </td>
          <td class="wrap-text">{{ emp.reportingManagerNames || emp.reportingManager || '—' }}</td>
          <td>{{emp.createdBy}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9">No Records found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>